import { useBapApi } from "@/api/useBapApi";
import { useToast } from "@/composables/useToast";
import { useToastTransaction } from "@/composables/useToast/useToastTransaction";
import { useMethBankStore } from "@/store/meth-bank";
import { useWalletCollectionStore } from "@/store/wallet-collection";
import { useWeb3Store } from "@/store/web3";
import { useOrchestratorContract } from "@/web3/contracts";
import { claimAllTokensMeth } from "./claimAllTokensMeth";
import { claimMethBankMeth } from "./claimMethBankMeth";
export const claimTokensAndMethBankMeth = async () => {
  try {
    const {
      genesis,
      gods,
      resurrectedTeens,
      totalClaimableMeth: totalClaimableTokensMeth,
    } = useWalletCollectionStore();
    const methBankStore = useMethBankStore();

    const harvestedBalance = methBankStore.balance;
    const canClaimHarvested = methBankStore.canClaimNow;
    if (!totalClaimableTokensMeth && canClaimHarvested) {
      console.log("claim without bulls");
      return await claimMethBankMeth();
    }
    if (!harvestedBalance || !canClaimHarvested) {
      console.log("claim without harvested");

      return await claimAllTokensMeth();
    }
    const walletAddress = useWeb3Store().walletAddress;

    const contract = useOrchestratorContract(true);
    const { success, result } = await useBapApi({
      toast: { error: true },
      throw: true,
    }).exec({
      method: "POST",
      url: "/mint/sign/claimteenmeth",
      data: {
        wallet: walletAddress,
      },
    });
    if (!success) {
      useToast().error({ title: "Cannot sign transaction. Please Try Again" });
      return;
    }

    const { signature, seed, amount } = result;

    const bullTokens = genesis.map((item) => item.id);
    const godTokens = gods.map((item) => item.id);
    const teenTokens = resurrectedTeens.map((item) => item.id);

    const claimResponse = await useToastTransaction(
      contract.methods.claimAllMeth(
        bullTokens,
        godTokens,
        teenTokens,
        amount,
        seed,
        signature
      ),
      {
        text: "Claiming Meth",
        successText: `Congrats! Your wallet now has +${
          totalClaimableTokensMeth + harvestedBalance
        } METH`,
      }
    );
    useWalletCollectionStore().fetchCollection(true)
    useWeb3Store().update()
    useMethBankStore().fetchMethBank()
    return claimResponse;
  } catch (err) {
    console.error(err)
  }
};
